import { render } from "./App.vue?vue&type=template&id=b48f30c4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b48f30c4&lang=scss"

import exportComponent from "D:\\node\\电脑版Windous\\myOfficial\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__